import { useState, useCallback } from 'react';
import { Tabs } from 'antd';
import {
  DatabaseOutlined,
  ImportOutlined,
  ExportOutlined,
  EditOutlined,
  AuditOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { useWarehouseHub } from '@hooks/useWarehouseHub';
import StockTable from './StockTable';
import ReceiptForm from './ReceiptForm';
import ShipmentForm from './ShipmentForm';
import AdjustmentForm from './AdjustmentForm';
import InventoryCountsPage from './InventoryCountsPage';
import InventoryCountDetailPage from './InventoryCountDetailPage';
import LowStockPage from './LowStockPage';

type WmsSubPage =
  | { type: 'none' }
  | { type: 'inventory-detail'; countId: string };

export default function WmsPage() {
  useWarehouseHub();
  const [mdSubPage, setMdSubPage] = useState<WmsSubPage>({ type: 'none' });

  const mdHandleViewCount = useCallback((mdCountId: string) => {
    setMdSubPage({ type: 'inventory-detail', countId: mdCountId });
  }, []);

  const mdHandleBackToInventory = useCallback(() => {
    setMdSubPage({ type: 'none' });
  }, []);

  const mdTabItems = [
    {
      key: 'stock',
      label: 'Залишки',
      icon: <DatabaseOutlined />,
      children: <StockTable />,
    },
    {
      key: 'receipt',
      label: 'Оприбуткування',
      icon: <ImportOutlined />,
      children: <ReceiptForm />,
    },
    {
      key: 'shipment',
      label: 'Відвантаження',
      icon: <ExportOutlined />,
      children: <ShipmentForm />,
    },
    {
      key: 'adjustment',
      label: 'Коригування',
      icon: <EditOutlined />,
      children: <AdjustmentForm />,
    },
    {
      key: 'inventory',
      label: 'Інвентаризація',
      icon: <AuditOutlined />,
      children:
        mdSubPage.type === 'inventory-detail' ? (
          <InventoryCountDetailPage
            countId={mdSubPage.countId}
            onBack={mdHandleBackToInventory}
          />
        ) : (
          <InventoryCountsPage onViewCount={mdHandleViewCount} />
        ),
    },
    {
      key: 'low-stock',
      label: 'Мін. залишки',
      icon: <WarningOutlined />,
      children: <LowStockPage />,
    },
  ];

  return (
    <Tabs
      defaultActiveKey="stock"
      items={mdTabItems.map((mdTab) => ({
        ...mdTab,
        label: (
          <span>
            {mdTab.icon} {mdTab.label}
          </span>
        ),
      }))}
      size="large"
    />
  );
}
